module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/id/2/3-0258fca3ae9272f5747e4b5a42aec0b5.jpg";